import React from "react";
import PropTypes from "prop-types";
import styles from "./TemplateButton.module.css";
import FeedTemplateIcon from "../FeedTemplateIcon";

/**
 * Interactive component. A button that allows the user to select a template.
 */

export function TemplateButton({ feedType }) {
  return (
    <>
      {feedType === "Standard Content" ? (
        <div className={styles.feedContainer}>
          <FeedTemplateIcon
            feedTemplateType="Standard Content"
            iconSize="72px"
            className={styles.feedIcon}
          />

          <h3 className={styles.feedText}>Standard Content</h3>
        </div>
      ) : feedType === "Standing Order" ? (
        <div className={styles.feedContainer}>
          <FeedTemplateIcon
            feedTemplateType="Standing Order"
            iconSize="72px"
            className={styles.feedIcon}
          />

          <h3 className={styles.feedText}>Standing Order</h3>
        </div>
      ) : (
        <div className={styles.feedContainer}>
          <FeedTemplateIcon
            feedTemplateType="Banner"
            iconSize="72px"
            className={styles.feedIcon}
          />

          <h3 className={styles.feedText}>Banner</h3>
        </div>
      )}
    </>
  );
}

TemplateButton.propTypes = {
  /**
   * String that states the type of feed template.
   */
  feedType: PropTypes.oneOf(["Standard Content", "Standing Order", "Banner"]),
};
